export default __webpack_public_path__ + "static/media/Pudsning_af_fedtende_klippet.63c7c99f.mp4";